// extracted by mini-css-extract-plugin
export var chevron = "_jk-2";
export var dropdownItems = "_jk-0";
export var item = "_jk-1";